import React from "react";

function CreatorCloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.447"
      height="22.447"
      viewBox="0 0 22.447 22.447"
    >
      <path
        id="Close_Icon"
        data-name="Close Icon"
        d="M16.86,14.366l8.729-8.729,2.494,2.494L19.354,16.86l8.729,8.729-2.494,2.494L16.86,19.354,8.131,28.083,5.637,25.589l8.729-8.729L5.637,8.131,8.131,5.637Z"
        transform="translate(-5.637 -5.637)"
      />
    </svg>
  );
}

export default CreatorCloseIcon;
